import PropTypes from "prop-types";
import { createElement } from "react";
import styled from "styled-components";

import { aStyles } from "./styles";

/**
 * @function A
 * @desc Browser controlled routing, e.g. download, external links, document id anchors. NOT client-side routing
 *
 * @param {*} children
 * @param {bool|string} download
 * @param {string} href External url or DOM element id
 * @param {string} hrefLang Language code
 * @param {string} rel Resource relationship
 * @param {"_self"|"_blank"|"_parent"|"_top"} target
 */
function Anchor({
  children,
  className,
  download,
  href,
  hrefLang,
  // ping,
  // referrerPolicy,
  rel = "noreferrer noopener",
  target = "_self",
  // type,
}) {
  return createElement(
    "a",
    {
      className,
      download,
      href,
      hrefLang,
      // ping,
      // referrerPolicy,
      rel,
      target,
      // type,
    },
    children
  );
}

Anchor.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  className: PropTypes.string,
  download: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  href: PropTypes.string.isRequired,
  hrefLang: PropTypes.string,
  // ping: PropTypes.string,
  // referrerPolicy: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
  // type: PropTypes.string,
};

export const A = styled(Anchor)([""], aStyles);
A.displayName = "A";
